import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { AtpSignalRHubConnection, AtpSignalRHubEvent } from '../atp-core/atp-core';
import { HttpErrorsService } from './http-errors.service';

export class OffersConnection extends AtpSignalRHubConnection {
  constructor(api: HttpService, httpErrors: HttpErrorsService) {
    super('Offers', api, httpErrors, [new AtpSignalRHubEvent<any>('BestSuggestionAndEndDate'), new AtpSignalRHubEvent<any>('ManagementInfo'), new AtpSignalRHubEvent<any>('Blocked'), new AtpSignalRHubEvent<any>('Reinit')], 100);
  }

  sendMessage(name: string, message: string) {
    if (this.isConnection) {
      this.connection.invoke('TestMessage', 'test');
    }
  }
}

export class MessagesConnection extends AtpSignalRHubConnection {
  constructor(api: HttpService, httpErrors: HttpErrorsService) {
    super('Messages', api, httpErrors, [new AtpSignalRHubEvent<any>('SubscriptionMessage')]);
  }
}

export class ChatsConnection extends AtpSignalRHubConnection {
  constructor(api: HttpService, httpErrors: HttpErrorsService) {
    super('Chats', api, httpErrors, [new AtpSignalRHubEvent<any>('AddMessage')]);
  }

  sendMessage(name: string, chatId: number, message: string) {
    return this.connection.invoke(name, chatId, message);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  constructor(private _api: HttpService, private _httpErrors: HttpErrorsService) {
    _api.authEvent.subscribe(
      (data) => {
        this.messages.start();
      }
    );
  }

  public offers = new OffersConnection(this._api, this._httpErrors);
  public messages = new MessagesConnection(this._api, this._httpErrors);
  public chats = new ChatsConnection(this._api, this._httpErrors);
}
